import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(duration);

const defaultTimeZone = 'Asia/Hong_Kong';

dayjs.tz.setDefault(defaultTimeZone);

export const formatForDatePicker = (value: Date | null): string | undefined => {
  const convertedDate = dayjs(value).tz();

  if (convertedDate.isValid()) {
    return convertedDate.format('YYYY-MM-DD');
  }
};

export const formatToDate = (value: string): string =>
  dayjs(value).tz().format('DDMMMYYYY');

export const convertToDate = (value: string): Date | undefined => {
  if (value) {
    return dayjs(value).tz().toDate();
  }
};

export const formatToFullDate = (value?: Date): string => {
  if (value) return dayjs(value).tz().format('DD MMM YYYY');

  return '';
};

export const formatToFullDateTime = (value?: Date): string => {
  if (value) return dayjs(value).tz().format('DD MMM YYYY HH:mm');

  return '';
};

export const getYear = (): number => dayjs().tz().year();

export const formatInDaysHoursMins = (value: number): string =>
  dayjs.duration(value, 'minutes').format('D[d]H[hr]m[m]');
